import { jsx } from 'react/jsx-runtime';
import { createSVG } from '../../utils/createSVG/createSVG/index.js';

const IconTagFilled = createSVG({
    // eslint-disable-next-line max-len
    children: jsx("path", { d: "M21.258 12.703l-.516.54-7.734 7.827c-.297.297-.64.532-1.031.703-.391.157-.805.235-1.243.235-.437 0-.851-.078-1.242-.235a3.354 3.354 0 0 1-1.031-.703L2.93 15.54a3.174 3.174 0 0 1-.938-2.298c0-.89.313-1.648.938-2.273l8.015-8.016c.375-.375.805-.64 1.29-.797.5-.156 1-.195 1.5-.117l5.718.938c.469.078.867.289 1.195.632.344.329.547.735.61 1.22l.703 5.484c.062.453.039.882-.07 1.289-.11.39-.32.757-.633 1.101zm-4.899-3.21c.532 0 .977-.18 1.336-.54.36-.375.54-.82.54-1.336 0-.515-.18-.953-.54-1.312a1.776 1.776 0 0 0-1.336-.563c-.515 0-.96.188-1.336.563-.359.36-.539.797-.539 1.312 0 .516.18.961.54 1.336.374.36.82.54 1.335.54z" }),
});

export { IconTagFilled };
